import React from 'react';
import { useSelector } from 'react-redux';
import { getConflicts } from 'ducks/core';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { isMobile } from 'utils/platform';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { ConflictFooter, MenuContent } from './ConflictMenuContent';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import Title from 'ui/Typography/Title';
import SlideOutMenu from 'components/SlideOutMenu/SlideOutMenu';
import { isConflictMenuOpen } from 'ducks/layout';
import Box from 'ui/Box';

const BottomSheetFooterWrapper = styled.div`
  bottom: 0;
  position: absolute;
  width: 100%;
  background-color: white;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ConfictMenuWrapper = styled.div`
  height: 100%;
  padding: 0 ${({ theme }) => theme.space.xxl};
  overflow-y: auto;
`;

function ConflictMenu() {
  const { formatMessage } = useIntl();
  const conflicts = useSelector(getConflicts);
  const conflictMenuOpen = useSelector(isConflictMenuOpen);

  if (isMobile()) {
    return (
      <>
        <BottomSheet
          open={conflicts.length > 0}
          header={
            <TitleWrapper>
              <Title display="flex" alignItems="center" type={ThemeFontStyleTypeEnum.headingSmall}>
                {formatMessage({ id: 'storageone.conflictMenuTitleCollision' })}
              </Title>
            </TitleWrapper>
          }
          defaultSnap={({ maxHeight }) => maxHeight * 0.55}
          snapPoints={({ maxHeight }) => {
            return [maxHeight * 0.43, maxHeight * 0.55, maxHeight * 0.88];
          }}
          blocking={false}
          expandOnContentDrag={true}
        >
          <MenuContent />
          <BottomSheetFooterWrapper>
            <ConflictFooter />
          </BottomSheetFooterWrapper>
        </BottomSheet>
      </>
    );
  }

  return (
    <SlideOutMenu trigger={conflictMenuOpen}>
      <Box style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <ConfictMenuWrapper>
          <Title
            display="flex"
            alignItems="center"
            type={ThemeFontStyleTypeEnum.headingMedium}
            my="mdl"
          >
            {formatMessage({ id: 'storageone.conflictMenuTitleCollision' })}
          </Title>
          <MenuContent />
        </ConfictMenuWrapper>
        <ConflictFooter />
      </Box>
    </SlideOutMenu>
  );
}

export default ConflictMenu;
